import { render, staticRenderFns } from "./prdNotificacoesModal.vue?vue&type=template&id=72b3384e&scoped=true&"
import script from "./prdNotificacoesModal.vue?vue&type=script&lang=js&"
export * from "./prdNotificacoesModal.vue?vue&type=script&lang=js&"
import style0 from "./prdNotificacoesModal.vue?vue&type=style&index=0&id=72b3384e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b3384e",
  null
  
)

export default component.exports